import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { reduxForm, InjectedFormProps, change } from 'redux-form';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { Modal, ErrorSummary } from 'components';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { Button } from 'components';
import { onCloseModalForm } from 'helpers/common';
import { ButtonsSection } from 'components/PortalStructure';

interface IProps extends InjectedFormProps {
	section: IPortalPageSection;
	baseUrl?: string;
	currentFormValues: IPortalPageSection;
	showHeaderCloseButton: boolean;
	index: number;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	change?: (field: any, value: any) => void;
	saveSection?: (form: IPortalPageSection, index?: number) => void;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IState {
	error: boolean;
	message: any;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType10Form extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			message: null,
		};
		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	private onSubmit(form: IPortalPageSection) {
		this.props.saveSection(form, this.props.index);
	}

	private onChange(field: string, value: any) {
		this.props.change(field, value);
		this.forceUpdate();
	}

	private closeModal() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	public render() {
		const { submitting, handleSubmit, t, showHeaderCloseButton } = this.props;
		const { error, message } = this.state;

		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<Modal
				title={t('PortalPage_Section_Manage_Common_EditSection')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
				modalClass="portalPageSectionManageWrapper"
			>
				<form onSubmit={handleSubmit(this.onSubmit)}>
					<div>
						<ErrorSummary {...errorSummaryProps} />
					</div>
					<ButtonsSection>
						<div className="row">
							<div className="col-sm-12">
								<Button type="submit" usage="admin" disabled={submitting}>
									{t('BSPortal_Common_SaveAndClose')}
								</Button>
							</div>
						</div>
					</ButtonsSection>
				</form>
			</Modal>
		);
	}
}

function mapStateToProps(state, ownProps: IProps) {
	const newProps = {
		type: c.PORTAL_PAGE_SECTION_TYPE_10,
		items: [],
	};

	let currentFormValues: IPortalPageSection = null;
	if (state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION10] && state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION10].values) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION10].values;
	}

	return {
		initialValues: ownProps.section || newProps,
		//formErrors: getFormSyncErrors(c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION10)(state),
		currentFormValues,
	};
}

let ManageType10 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION10,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType10Form);

ManageType10 = connect(mapStateToProps, (dispatch) => ({
	change: (field: string, value: string) => dispatch(change(field, value)),
}))(ManageType10);

export { ManageType10 };
